import './City.css'
import BackHome from '../nav/BackHome'
function City () {
    return(
        <div className='city'>
        <BackHome/>
            City
        </div>
    )
}
export default City;